export default "__VITE_ASSET__56caffa6__"